export default "__VITE_ASSET__BOG3n02f__"